// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q26NF","messages":"styles_messages__2RpRF"};